import { render } from "./FormBuilder.vue?vue&type=template&id=b9bf7c5c&ts=true"
import script from "./FormBuilder.vue?vue&type=script&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/FormBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9bf7c5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9bf7c5c', __exports__)) {
    api.reload('b9bf7c5c', __exports__)
  }
  
  module.hot.accept("./FormBuilder.vue?vue&type=template&id=b9bf7c5c&ts=true", () => {
    api.rerender('b9bf7c5c', render)
  })

}


export default __exports__